import React from 'react'
import "./styles/about.css" 

const About = () => {
  return (
    <div>
   
<div className='MaratT Eram'>
    <div className='AboutM'>
          <p className='MaratB'>About Marat Technology</p>
     <p className='Pa'>At Marat Technology, we're passionate about transforming ideas into compelling online experiences. Our mission is to supercharge individuals and businesses with a compelling online presence. We achieve this by crafting dynamic websites that perfectly align with your unique needs and goals. Let us transform your online identity into a powerful tool for success!</p>

</div>
<img  className='AboutM' src="/img/AboutM.svg"  alt="" />
</div>

<div className='MaratT'>
 
        <img src="/img/about10.svg" alt="img" className='AboutM'/>
       
  
     <div className='AboutM'><p className='OurService'>Our Services</p>
     <p className='Pa'>Our core offering includes website design and development,app development,project development tailored to your specific requirements. We specialize in crafting websites and mobile app that not only look visually appealing but also function seamlessly. From concept to execution, our team of skilled professionals is dedicated to bringing your vision to life in the digital realm.</p>
     </div>
    
</div>
<div  className='MaratT Eram'>
    <div className='AboutM'>
        <p className='OurService'>Project Expertise</p>
         <p className='Pa'>With a finger on the pulse of modern technology trends, we excel in creating specialized project-based websites. Whether you're venturing into the world of ecommerce or investment, aiming to launch  an online presence etc, we have the expertise to deliver innovative solutions that drive results.</p>
    </div>
    {/* <div> */}
        <img src="/img/about10.svg" alt="" className='AboutM'/>   
         {/* </div> */}
</div>
<div className='MaratT'>
    {/* <div> */}
        <img src="/img/about10.svg" alt="" className='AboutM' />
        {/* </div> */}
     <div className='AboutM'>
        <p className='OurService'>Education and Empowerment</p>
        <p className='Pa'>Marat Technology goes beyond just website creation. We understand that navigating the digital landscape can be challenging. That's why we offer related courses that empower you with the knowledge needed to make the most of your online presence. Our courses cover a range of topics, ensuring you have the tools to manage and grow your website effectively.</p>
     </div>
</div>
<div className='MaratT Eram'>
    <div className='AboutM'>
        <p className='OurService'>Your Privacy Matters</p>
        <p className='Pa'>We value your privacy and are committed to safeguarding your personal information. Our Privacy Policy outlines how we collect, use, and protect your data, ensuring transparency and trust in our interactions.</p>
    </div>
    {/* <div> */}
        <img src="/img/about10.svg" alt="" className='AboutM'/>
    {/* </div> */}
 </div>
<div className='MaratT'>
    {/* <div> */}
        <img src="/img/about10.svg" alt="" className='AboutM'/>
        {/* </div> */}
    <div className='AboutM'>
        <p className='OurService'>Join Us on the Journey</p>
        <p className='Pa'>We believe in collaboration, creativity, and constant innovation. When you choose Marat Technology, you're not just getting a service; you're becoming a part of our journey to reshape the digital landscape. Join us as we work together to build websites that stand out, enhance user experiences, and drive success</p>
    </div>
</div>
<div className='MaratT Eram'>
    <div className='AboutM'>
        <p className='OurService'>Contact Us</p>
        <p className='Pa pa1'>Have questions? Interested in discussing your project? We're here to listen and assist you every step of the way. Feel free to reach out to us at <a href="">chukwubuikekingsley369@gmail.com</a> to start a conversation.</p>
        <p className='Pa'>Empower your online presence with Marat Technology .</p>
    </div>
    {/* <div> */}
        <img src="/img/about10.svg" alt="" className='AboutM'/>
    {/* </div> */}
</div>




    </div>
  )
}

export default About